<template>
  <v-footer class="pa-0 footer-background">
    <v-card flat tile class="footer-card text-center footer-background">
      <v-card-text>
        <strong>{{enums.titles.PRODUCT}}</strong> un producto de
        <a href="https://www.macena.com.ar/" target="_blank" color="primary">
          Macena
        </a>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
import enums from "@/utils/enums/index";

export default {
  name: "TheFooter",
  data() {
    return {
      enums: enums
    };
  },
};
</script>

<style lang="scss" scoped>
.footer-card {
  width: 100%;
}

// Aplicar el color de fondo personalizado al footer
.footer-background {
  background-color: rgb(var(--v-theme-background)) !important;
}

// Asegurar que la tarjeta del footer también tenga el fondo correcto
.footer-card.footer-background {
  background-color: rgb(var(--v-theme-background)) !important;
}
</style>